import { render, staticRenderFns } from "./RedditiPatrimonioModal.vue?vue&type=template&id=86fadcc4&scoped=true&"
import script from "./RedditiPatrimonioModal.vue?vue&type=script&lang=js&"
export * from "./RedditiPatrimonioModal.vue?vue&type=script&lang=js&"
import style0 from "./RedditiPatrimonioModal.vue?vue&type=style&index=0&id=86fadcc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fadcc4",
  null
  
)

component.options.__file = "RedditiPatrimonioModal.vue"
export default component.exports